export const bytecodeEditingIntro = [
    {
      title: "Introducción a la obtención y edición del Bytecode para despliegue",
      value: `
  En esta sección vamos a aprender a **obtener y editar el bytecode** de nuestro contrato inteligente para prepararlo antes de desplegarlo en la blockchain.
  
  ---
  
  ### ¿Qué necesitas tener listo antes de empezar?
  
  1. **Tu editor de texto abierto** con el contrato de token que ya editaste en la sección anterior.  
     - Ten este archivo listo para copiar y pegar cuando sea necesario.  
     - Puede ser cualquier editor, como Sublime Text, VSCode o similar.
  
  2. **Un archivo nuevo y vacío en tu editor**, que será exclusivo para pegar y modificar el bytecode que obtendremos.  
     - Esto facilitará trabajar con el código compilado sin perder el contrato fuente original.
  
  3. **La página Remix Ethereum lista para usar** en tu navegador ([https://remix.ethereum.org](https://remix.ethereum.org))  
     - Remix es una herramienta en línea para compilar y desplegar contratos Ethereum.  
     - La usaremos para compilar nuestro contrato y obtener el bytecode.
  
  ---
  
  ### ¿Cuál será el proceso?
  
  - Copiarás el contrato fuente desde tu editor y lo pegarás en Remix.  
  - Compilarás el contrato en Remix para generar el bytecode.  
  - Copiarás el bytecode generado y lo pegarás en el archivo nuevo que creaste en tu editor de texto.  
  - Editarás el bytecode según sea necesario (por ejemplo, para ajustar parámetros o valores específicos).  
  - Finalmente, usarás este bytecode editado para desplegar el contrato en la blockchain de Ethereum.
  
  ---
  
  ### ¿Por qué es importante este proceso?
  
  - El bytecode es lo que la blockchain realmente ejecuta, por eso debemos obtenerlo y asegurarnos de que esté correcto antes de desplegarlo.  
  - Editar el bytecode te da un control más fino sobre el contrato que vas a subir, especialmente si necesitas hacer ajustes específicos o integrar datos en caliente.  
  - Usar Remix facilita la compilación porque es una plataforma confiable, gratuita y accesible en línea.
  
  ---
  
  
  `
    }
  ];
  
  export default bytecodeEditingIntro;
  